var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplyFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3L2 8l6 5v-3c1.636 0 4.364.5 6 2 0-5-4.91-6-6-6V3z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggM0wyIDhMOCAxM1YxMEM5LjYzNjM2IDEwIDEyLjM2MzYgMTAuNSAxNCAxMkMxNCA3LjAwMDAyIDkuMDkwOTEgNi4wMDAwMiA4IDYuMDAwMDJWM1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgReplyFull as ReactComponent };